export const selectNotificationState = state => {
  return state.notificationState
}
